/* If you edit this file, please remove this header and clean up the resulting eslint errors.
*/
/* eslint-disable
  import/no-commonjs,
  eqeqeq,
  import/no-extraneous-dependencies,
  prefer-const,
  react/prop-types
*/
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import createReactClass from 'create-react-class';


const ToggleChoice = createReactClass({

  handleClick() {
    this.props.handleSelection(this.props.value);
  },

  render() {
    const classes = cx({
      'small-6': true,
      columns: true,
      'm-toggle--choice': true,
      'is-active': this.props.isActive,
      'is-inactive': !this.props.isActive,
    });

    return <div className={classes} onClick={this.handleClick}>{this.props.name}</div>;
  },
});

const Toggle = createReactClass({

  propTypes: {
    initialSelection: PropTypes.string,
  },

  getInitialState() {
    let selected = this.props.choices[0].value;
    if (this.props.initialSelection) {
      for (let i = 0; i < this.props.choices.length; i++) {
        if (this.props.initialSelection == this.props.choices[i].value) {
          selected = this.props.choices[i].value;
          break;
        }
      }
    }
    return { selected };
  },

  handleSelection(selected) {
    this.setState({ selected });
    this.props.onSelection(selected);
  },

  renderChoice(choice, i) {
    const { isEventbrite } = this.props;
    const { selected } = this.state;
    let { value, name } = choice;
    const isActive = selected === value;

    name = isEventbrite && name === 'ANNUAL' ? 'ANNUAL - SAVE 20%!' : name;

    const props = {
      key: i,
      value,
      name,
      isActive,
      handleSelection: this.handleSelection,
    };

    return <ToggleChoice {...props} />;
  },

  render() {
    const { isEventbrite } = this.props;
    const classes = cx({
      'small-12': true,
      'small-centered': true,
      'large-3': !isEventbrite,
      'large-4': isEventbrite,
      'large-centered': true,
      'columns m-toggle': true,
    });
    const choices = this.props.choices.map(this.renderChoice);
    return <div className={classes}>{choices}</div>;
  },
});

exports.Toggle = Toggle;
exports.ToggleChoice = ToggleChoice;
